/** Mismo cupo que el backend: solo pruebas activas y no dadas de baja. */
export const MAX_ACTIVE_EVENTS = 12;
export const EVENT_CAP_DETAIL = `Máximo ${MAX_ACTIVE_EVENTS} pruebas por disciplina`;

export function eventConsumesQuota(event) {
  if (!event) return false;
  if (event.deleted_at) return false;
  return Boolean(event.is_active);
}

export function activeEventCount(events) {
  return (events || []).filter(eventConsumesQuota).length;
}

export function canAddActiveEvent(events, maxEvents = MAX_ACTIVE_EVENTS) {
  return activeEventCount(events) < maxEvents;
}
